import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

const splashImages = [
    '/images/bg-1.jpg',
    '/images/bg-2.jpg',
    '/images/bg-3.jpg',
    '/images/bg-4.jpg',
    '/images/bg-5.jpg',
];

export default function Splash(props) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [loaded, setLoaded] = useState(false);
    const [rotations, setRotations] = useState([]);
    const opacity = props.splashTimeLeft / props.splashTime;

    useEffect(() => {
        const newRotations = splashImages.map((_, index) => {
            const rotationStart = (index % 2 === 0 ? -3 : 3) + (Math.random() * 2 - 1);
            const rotationEnd = (index % 2 === 0 ? 3 : -3) + (Math.random() * 2 - 1);
            return { rotationStart, rotationEnd };
        });
        setRotations(newRotations);

        let loadedCount = 0;
        let mounted = true;
        splashImages.forEach(src => {
            const img = new Image();
            img.src = src;
            img.onload = () => {
                if (!mounted) return;
                loadedCount++;
                if (loadedCount === splashImages.length) {
                    setLoaded(true);
                }
            };
            img.onerror = () => {
                if (!mounted) return;
                loadedCount++; // Count even if it fails to avoid getting stuck
                if (loadedCount === splashImages.length) {
                    setLoaded(true);
                }
            }
        });
        return () => { mounted = false; };
    }, []);

    useEffect(() => {
        if (!loaded) return;

        const intervalTime = props.splashTime / splashImages.length;
        const interval = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % splashImages.length);
        }, intervalTime);

        return () => clearInterval(interval);
    }, [loaded, props.splashTime]);

    return (
        <div className="splash-wrap" style={{ opacity }}>
            {splashImages.map((src, index) => {
                const rotation = rotations[index] || { rotationStart: 0, rotationEnd: 0 };
                return (
                    <div
                        key={src}
                        className={`splash-bg ${index === currentIndex ? 'active' : ''}`}
                        style={{ 
                            backgroundImage: `url('${src}')`,
                            '--rotation-start': `${rotation.rotationStart}deg`,
                            '--rotation-end': `${rotation.rotationEnd}deg`
                        }}
                    />
                );
            })}
            <div className="container">
                <div className="row splash-row">
                    <div className="Quote col-sm-offset-3 col-sm-6 col-md-offset-2 col-md-8">
                        Wheelie Ben
                    </div>
                </div>
            </div>
        </div>
    );
}

Splash.propTypes = {
    splashTime: PropTypes.number.isRequired,
    splashTimeLeft: PropTypes.number.isRequired
};
